module.exports = __webpack_public_path__ + "static/media/download-gray.9828727e.svg";